import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchUserDetails } from "../../../pages/user/redux/userThunk";

const UserDetails = ({ userId, onClose }) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (userId) {
      setLoading(true);
      dispatch(fetchUserDetails(userId))
        .unwrap()
        .then((data) => {
          setUser(data);
          setLoading(false);
        })
        .catch((err) => {
          setError(err?.message || "Failed to load user details");
          setLoading(false);
        });
    }
  }, [userId, dispatch]);

  if (loading && !user) {
    return <div style={{ padding: "20px", textAlign: "center" }}>Loading user details...</div>;
  }

  if (error) {
    return <div style={{ padding: "20px", color: "red", textAlign: "center" }}>{error}</div>;
  }

  return (
    <div style={{ padding: "16px" }}>
      {user ? (
        <div>
          <table className="table table-sm table-borderless" style={{ fontSize: "14px", marginBottom: "20px" }}>
            <tbody>
              <tr>
                <td style={{ fontWeight: "600", width: "100px" }}>Name:</td>
                <td>{user.name || "N/A"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "600" }}>Email:</td>
                <td>{user.email || "N/A"}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "600" }}>Role:</td>
                <td>{user.role_name || "N/A"}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              style={{ padding: "6px 16px", borderRadius: "5px" }}
            >
              Close
            </button>
          </div>
        </div>
      ) : (
        <div style={{ textAlign: "center" }}>No user data found.</div>
      )}
    </div>
  );
};

export default UserDetails;
